import { CustomerType } from "@TmpApp/types";
import { SettingsProps } from "@TmpApp/types/widgets";
import * as React from "react";
import { FindDealerIconsProps } from ".";

export default function FindDealerIcons({ dealer, ...props }: FindDealerIconsProps) {
    const types = React.useMemo(
        () =>
            removeDuplicateImages(
                dealer.types.filter(
                    (type) =>
                        type.brand_logo_url &&
                        type.brand?.id &&
                        (tmp_settings.customer_types.some((t) => parseInt(t) === type.id) ||
                            !tmp_settings.customer_types?.length)
                )
            ),
        [dealer.types]
    );

    const { dealerTypes, workshopTypes } = React.useMemo(() => {
        const workshopTypes = [];
        const dealerTypes = types.filter((type) => {
            if (type.is_workshop) {
                workshopTypes.push(type);
                return false;
            }

            return true;
        });

        return { workshopTypes, dealerTypes };
    }, [types]);

    return (
        <>
            {dealerTypes.length > 0 && (
                <>
                    <div style={{ marginBottom: "0.2em" }}>
                        {props.settings?.find_dealer_is_dealer_text}
                    </div>
                    <FindDealerIconsList settings={props.settings} types={dealerTypes} />
                </>
            )}
            {workshopTypes.length > 0 && (
                <>
                    <div style={{ marginBottom: "0.2em" }}>
                        {props.settings?.find_dealer_is_workshop_text}
                    </div>
                    <FindDealerIconsList settings={props.settings} types={workshopTypes} />
                </>
            )}
        </>
    );
}

interface FindDealerIconsListProps extends SettingsProps {
    types: CustomerType[];
}

export function FindDealerIconsList({ types, ...props }: FindDealerIconsListProps) {
    return (
        <div className="tmp-find-dealer__icons" style={{ marginBottom: "0.9rem" }}>
            {types.map((type, index) => (
                <div
                    key={type.id}
                    className="tmp-find-dealer__icons__brand-icon"
                    title={
                        type.brand &&
                        type.brand.name +
                            " " +
                            (type.is_workshop
                                ? props.settings?.find_dealer_is_workshop_text
                                : props.settings?.find_dealer_is_dealer_text)
                    }
                    style={{ backgroundImage: "url(" + type.brand_logo_url + ")" }}
                />
            ))}
        </div>
    );
}

const removeDuplicateImages = (a: CustomerType[]): CustomerType[] => {
    var seen = {};
    var out = [];
    var len = a.length;
    var j = 0;
    for (var i = 0; i < len; i++) {
        var item = a[i];
        if (seen[item.brand?.id] !== 1) {
            seen[item.brand?.id] = 1;
            out[j++] = item;
        }
    }
    return out;
};
